import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from '../actions/customer.actions';
import * as DeviceActions from '../actions/customer.devices.actions';
export var INITIAL_STATE = Immutable({
  filterData: {
    includeRemoved: false
  },
  createDeviceModel: {},
  selectedDevice: {}
});
export default function DevicesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case DeviceActions.SET_INCLUDED_FILTER:
      return state.setIn(['filterData', 'includeRemoved'], payload);
    case DeviceActions.CLEAR_DEVICE_FORM:
    case DeviceActions.CREATE_EDIT_DEVICE_FORM_CHANGED:
      return state.set('createDeviceModel', payload);
    case DeviceActions.SET_SELECTED_DEVICE:
      return state.set('selectedDevice', payload);
    case RESET_CUSTOMER_RECOVERABLE:
    case DeviceActions.CLEAR_DEVICE_FILTERS:
      return INITIAL_STATE;
    default:
      return state;
  }
}